import { Layout } from "./Layout";
import { Loader } from "./Loader";

export function ContributionDetailPage(): React.ReactNode {
  return <Loader>{(data) => <Layout {...data} />}</Loader>;
}
